import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Person } from '@shared/models/person';
import { Company } from '@shared/models/company';
import { WinterStorageBoatAssignment } from '@shared/models/winter-storage-boat-assignment';
import { InvoicePosition } from '@shared/models/invoice-position';
import {
    buildWinterStorageBillingPayload,
    WinterStorageBillingPayload
} from './winter-storage-assignment-billing.helper';

@Component({
    selector: 'winter-storage-assignment-billing-panel',
    templateUrl: './winter-storage-assignment-billing-panel.component.html',
    standalone: false
})
export class WinterStorageAssignmentBillingPanelComponent implements OnChanges, OnDestroy {

    private _unsubscribeAll = new Subject<void>();

    @Input() winterStorageAssignment: WinterStorageBoatAssignment;
    @Input() subscription = false;

    formGroup: UntypedFormGroup;
    positions: InvoicePosition[] = [];
    owner: Person | Company;

    constructor(private _formBuilder: UntypedFormBuilder) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.winterStorageAssignment?.currentValue) {
            this._createForm();
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(undefined);
        this._unsubscribeAll.complete();
    }

    getBillingPayload(): WinterStorageBillingPayload | null {
        if (!this.formGroup?.valid) {
            return null;
        }

        return buildWinterStorageBillingPayload(
            this.formGroup.value,
            this.formGroup.get('invoiceRecipientType').value,
            this.winterStorageAssignment,
            this.positions,
            this.subscription,
            this.subscription ? this.formGroup.get('subscriptionPeriodForm')?.value : null
        );
    }

    markAllAsTouched(): void {
        this.formGroup?.markAllAsTouched();
    }

    private _createForm(): void {
        this.owner = this.winterStorageAssignment?.person || this.winterStorageAssignment?.company;

        this.formGroup = this._formBuilder.group({
            ownerPerson: [this.winterStorageAssignment?.person],
            ownerCompany: [this.winterStorageAssignment?.company],
            deviatingInvoiceRecipient: [!this.owner],
            invoiceRecipientType: ['person'],
            winterStorageAssignment: [this.winterStorageAssignment],
        });

        this.positions = [];

        setTimeout(() => {
            this.formGroup.get('invoiceForm')?.valueChanges
                .pipe(
                    takeUntil(this._unsubscribeAll),
                    map(value => value?.positions),
                    filter(value => !!value)
                )
                .subscribe(positions => {
                    this.positions = positions;
                    this.formGroup.markAsDirty();
                });
        }, 1000);
    }
}
